// extracted by mini-css-extract-plugin
export default {"square":"AskCopilotButton-module__square--o8kDO","muted":"AskCopilotButton-module__muted--QatcG"};